import { useCartStore } from '../../hooks';
import { CartItem } from './CartItem';
import { CartSummary } from './CartSummary';

interface CartProps {
  onCheckout: () => void;
}

export function Cart({ onCheckout }: CartProps) {
  const { items, clearCart } = useCartStore();
  const itemCount = items.reduce((count, item) => count + item.quantity, 0);

  return (
    <div className="h-full flex flex-col bg-white rounded-xl border border-gray-200 shadow-sm">
      <div className="px-4 py-3 border-b border-gray-100">
        <div className="flex items-center justify-between">
          <h2 className="font-semibold text-gray-900 flex items-center gap-2">
            <svg className="w-5 h-5 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
            Keranjang
          </h2>
          {itemCount > 0 && (
            <span className="bg-primary-100 text-primary-700 text-sm font-medium px-2 py-0.5 rounded-full">
              {itemCount} item
            </span>
          )}
        </div>
      </div>

      <div className="flex-1 overflow-y-auto px-4">
        {items.length > 0 ? (
          <div className="divide-y divide-gray-50">
            {items.map((item) => (
              <CartItem key={item.productId} item={item} />
            ))}
          </div>
        ) : null}
      </div>

      <div className="px-4 py-4 border-t border-gray-100 bg-gray-50 rounded-b-xl">
        <CartSummary onCheckout={onCheckout} onClear={clearCart} />
      </div>
    </div>
  );
}
